<template>
  <div>
    <el-table
      v-loading="loading"
      :data="data"
      size="medium"
      border
    >
      <el-table-column
        label="STT"
        width="80"
        fixed="left"
        align="center"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row.stt }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="field in fields"
        :key="field.key"
        :prop="field.key"
        :label="field.label"
        :width="field.width"
        :align="field.align"
      >
        <template slot-scope="scope">
          <span v-if="field.key === 'created'">
            {{ scope.row[field.key] | convertDateTime("HH:mm DD/MM/YYYY") }}
          </span>
          <span v-else-if="field.key === 'action'">
            <el-tag :type="scope.row[field.key] | roleAction('type')">
              {{ scope.row[field.key] | roleAction('label') }}
            </el-tag>
          </span>
          <span v-else-if="field.key === 'account_id'">
            {{ (scope.row.log_account_id || scope.row.log_data.executing_user_id) | accountName(accounts) }}
          </span>
          <span v-else-if="field.key === 'object_type'">
            {{ (scope.row.object_type) | configName(allConfigs) }}
          </span>
          <span v-else-if="field.key === 'object'">
            {{ scope.row.log_data.model.id | documentName(documentData) }}
          </span>
          <span v-else>
            {{ scope.row[field.key] }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import constants from "@/config/constants";

export default {
  name: "CardList",
  components: {},
  props: {
    data: Array,
    accounts: Array,
    documentData: Array,
    loading: Boolean,
  },
  data() {
    return {
      fileType: constants.FILE_TYPE,
    };
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
    fields() {
      return [
        {
          key: "object_type",
          label: "Module",
        },
        {
          key: "object",
          label: "Đối tương",
        },
        {
          key: "action",
          label: "Hành động",
          width: "200px",
          align: "center"
        },
        {
          key: "account_id",
          label: "Người thực hiện",
        },
        {
          key: "created",
          label: "Ngày tạo",
          width: "200px",
          align: "center"
        },
      ];
    },
  },
  methods: {
    //
  },
};
</script>

<style lang="scss"></style>
